// extracted by mini-css-extract-plugin
module.exports = {"Root":"uomnytIjntTZOxZ8Onye4Q=="};